import { Button } from '../Common/Button';

export type CompletedFirmwareUpload = {
  fileName: string;
  firmwareNumber: string;
  firmwareSemantic: string;
  targets: { productCode: string; variant: string }[];
};

type FirmwareUploadCompleteProps = CompletedFirmwareUpload & {
  action: 'uploaded' | 'imported';
  onClose: () => void;
};

export function FirmwareUploadComplete({
  action,
  onClose,
  fileName,
  firmwareNumber,
  firmwareSemantic,
  targets,
}: FirmwareUploadCompleteProps) {
  return (
    <section
      role="status"
      className="mt-4 rounded-lg border border-green-300 bg-green-50 p-5 text-green-950"
    >
      <div className="flex items-start gap-3">
        <span
          aria-hidden="true"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-green-600 font-bold text-white"
        >
          ✓
        </span>
        <div>
          <h2 className="text-xl font-bold">Firmware {action}</h2>
          <p className="mt-1">
            {action === 'uploaded'
              ? 'Upload Success!'
              : 'Import Success!'}{' '}
            The firmware is stored in FWM.
          </p>
        </div>
      </div>
      <dl className="mt-4 grid gap-3 border-t border-green-200 pt-4 text-sm">
        <div>
          <dt className="font-semibold">File</dt>
          <dd className="break-all">{fileName}</dd>
        </div>
        <div>
          <dt className="font-semibold">Release</dt>
          <dd>
            {firmwareNumber} ({firmwareSemantic})
          </dd>
        </div>
        <div>
          <dt className="font-semibold">Product variants</dt>
          <dd>
            {targets
              .map(
                ({ productCode, variant }) =>
                  `p${productCode}_v${variant}`,
              )
              .join(', ')}
          </dd>
        </div>
      </dl>
      <div className="mt-5 flex justify-end">
        <Button text="Done" onClick={onClose} />
      </div>
    </section>
  );
}
